import { useEffect } from 'react';

import GenericPageLayout, {
  GenericPageLayoutProps,
} from 'components/general/genericPageLayout/GenericPageLayout';
import CustomMetaData, {
  CustomMetaDataProps,
} from 'components/general/customMetaData/CustomMetaData';
import { StaffMemberCard, StaffMemberCardType } from 'components/staffmemberCard/StaffmemberCard';
import { useThemeContext } from 'context/ThemeContext';
import { NEXTJS_REVALIDATE_PAGE_IN_SECONDS } from 'pages/index';
import { getEndpoint } from 'utils/helpers';
import { parseGenericPage } from 'utils/parsers';

import blockStyle from 'components/general/standardBlocksLayout/StandardBlocksLayout.module.scss';
import style from './aboutPage.module.scss';
import { StandardBlocksLayout } from 'components/general/standardBlocksLayout/StandardBlocksLayout';
import { BlockType } from 'components/general/switchBlock/SwitchBlock';

type Props = {
  generic: GenericPageLayoutProps;
  staffMembers: StaffMemberCardType[];
  peopleHeading: string;
  servicesHeading: string;
  services: BlockType[];
  metaData: CustomMetaDataProps;
};

const About = (props: Props) => {
  const { setTheme } = useThemeContext();

  useEffect(() => {
    setTheme('light');
  }, [setTheme]);

  return (
    <GenericPageLayout {...props.generic} blockStyles={blockStyle.aboutBlocks}>
      <CustomMetaData {...props.metaData} />
      {props.services &&
        <>
          <StandardBlocksLayout blocks={[{
            'block_type': 'text',
            'text': `<h3 style="text-align: center;">${props.servicesHeading}</h3>`,
            'text_position': 'left'
          }]} blockStyles={blockStyle.aboutBlocks}/>
          <div className={style.gutter}>
            <div className={style.secondaryContent}>
              <div className={style.servicesGrid}>
                <StandardBlocksLayout blocks={props.services} blockStyles={blockStyle.aboutBlocks}/>
              </div>
            </div>
          </div>
        </>
      }
      <StandardBlocksLayout blocks={[{
        'block_type': 'text',
        'text': `<h3 style="text-align: center;">${props.peopleHeading}</h3>`,
        'text_position': 'left'
      }]} blockStyles={blockStyle.aboutBlocks}/>
      <div className={style.gutter}>
        <div className={style.secondaryContent}>
          <div className={style.staffGrid}>
            {props.staffMembers.map((staffMember) => {
              return (
                <div key={staffMember.slug}>
                  <StaffMemberCard {...staffMember} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </GenericPageLayout>
  );
};

export async function getStaticProps(context) {
  const genericProps: GenericPageLayoutProps = await parseGenericPage('/about-page/', context);
  const staff = await getEndpoint('/staff/', context);

  const props: Props = {
    generic: genericProps,
    staffMembers: staff,
    peopleHeading: genericProps.originalResponse.people_heading,
    servicesHeading: genericProps.originalResponse.services_heading,
    services: genericProps.originalResponse.services,
    metaData: {
      titleDefault: genericProps.originalResponse.title,
      title: genericProps.originalResponse.meta_title,
      description: genericProps.originalResponse.meta_description,
      image: genericProps.originalResponse.meta_image,
    },
  };
  // Pass data to the page via props
  return {
    props,
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: NEXTJS_REVALIDATE_PAGE_IN_SECONDS, // In seconds
  };
}

export default About;
